import React from 'react';

// 소셜 로그인 아이콘들
export const Kakao = ({ color = 'currentColor', size = 24, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        {...props}
    >
        <path
            d="M12.0004 0.898926C5.3725 0.898926 -0.00286865 5.28273 -0.00286865 10.6972C-0.00286865 14.1743 2.22165 17.2273 5.56821 18.9691L4.43312 23.3333C4.39398 23.4638 4.4266 23.6073 4.51792 23.7051C4.63535 23.8356 4.83758 23.8421 4.96805 23.7247L9.83459 20.3325C10.5522 20.4368 11.2698 20.4956 11.9939 20.4956C18.6218 20.4956 23.9971 16.1052 23.9971 10.6972C23.9971 5.28925 18.6218 0.898926 11.9939 0.898926"
            fill={color}
        />
    </svg>
);

export const Apple = ({ color = 'currentColor', size = 30, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 30 30"
        fill="none"
        {...props}
    >
        <path
            d="M20.9049 7.45551C21.5769 7.56708 22.2263 7.78786 22.8269 8.10915C23.5971 8.53079 24.2491 9.13859 24.7241 9.87705C24.689 9.90136 24.5283 10.0121 24.246 10.216C23.8947 10.4791 23.5732 10.7798 23.2872 11.1128C22.9036 11.5562 22.5929 12.0576 22.3663 12.5984C22.0895 13.2735 21.9557 13.9987 21.9733 14.7282C21.9495 15.5543 22.1196 16.3744 22.4701 17.1228C22.7569 17.7217 23.1531 18.2617 23.6384 18.715C23.9956 19.0571 24.3923 19.3555 24.8201 19.6037C25.1618 19.7915 25.3522 19.8887 25.3846 19.9008C25.3738 19.9333 25.2334 20.3222 24.9606 21.065C24.6198 21.9349 24.1728 22.7592 23.6291 23.519C23.1072 24.2818 22.5285 25.0042 21.8977 25.6798C21.6173 25.9955 21.2722 26.2475 20.8862 26.4187C20.5001 26.5899 20.0818 26.6765 19.6596 26.6725C19.1699 26.6905 18.6823 26.6011 18.2309 26.4105C17.8595 26.2376 17.4732 26.0661 17.0762 25.8959C16.5652 25.71 16.0231 25.6242 15.4797 25.6434C14.9278 25.629 14.3783 25.7179 13.8591 25.9054C13.4228 26.081 13.0095 26.2525 12.6232 26.428C12.1914 26.6112 11.7255 26.7005 11.2565 26.69C10.8587 26.689 10.4655 26.6044 10.1025 26.4415C9.73953 26.2786 9.41483 26.0412 9.1496 25.7447C8.47372 25.0254 7.851 24.258 7.28599 23.4487C6.4753 22.2567 5.83878 20.9552 5.39535 19.5834C4.88591 18.1059 4.62369 16.5544 4.61984 14.9916C4.57267 13.5412 4.89842 12.103 5.56549 10.8143C6.12056 9.76363 6.94972 8.88291 7.96523 8.26581C8.88872 7.70498 9.94793 7.40704 11.0284 7.40415C11.569 7.40202 12.1059 7.49342 12.6153 7.67428C13.1141 7.85435 13.5742 8.0376 13.9956 8.22397C14.3641 8.39769 14.7644 8.49289 15.1717 8.50354C15.5808 8.48713 15.9825 8.38932 16.3534 8.21585C16.8072 8.02543 17.3124 7.8296 17.8688 7.63377C18.4456 7.43213 19.0529 7.33161 19.6639 7.33664C20.0795 7.35226 20.4939 7.39196 20.9049 7.45551ZM17.1342 6.54386C16.5755 6.85974 15.9484 7.03498 15.3069 7.0544C15.1903 7.05646 15.0738 7.04557 14.9597 7.02196C14.921 6.87343 14.9031 6.72029 14.9059 6.56682C14.9068 5.90266 15.0528 5.24672 15.3339 4.64498C15.5776 4.08589 15.9032 3.5661 16.2997 3.10265C16.7903 2.53708 17.3865 2.07281 18.0551 1.7359C18.673 1.39502 19.3591 1.19617 20.0635 1.15381C20.1014 1.32539 20.1196 1.50075 20.1176 1.67646C20.1163 2.33334 19.9861 2.9836 19.7341 3.59023C19.4958 4.18842 19.1667 4.74639 18.7588 5.24462C18.3097 5.78125 17.7578 6.22254 17.1355 6.5425L17.1342 6.54386Z"
            fill={color}
        />
    </svg>
);

export const Google = ({ color = 'currentColor', size = 26, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 26 26"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_331_2879)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M25 13.2777C25 12.3888 24.9167 11.5416 24.7778 10.7222H13V15.5555H19.7222C19.4306 17.1111 18.5556 18.4444 17.2222 19.3333V22.4722H21.2639C23.625 20.2916 24.9861 17.0972 24.9861 13.2777H25Z"
                fill="#4285F4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 25.5C16.375 25.5 19.2083 24.375 21.2778 22.4722L17.2361 19.3333C16.1111 20.0833 14.6805 20.5278 13 20.5278C9.74998 20.5278 6.98609 18.3333 5.99998 15.375H1.83331V18.6111C3.88887 22.6944 8.11109 25.5 13 25.5Z"
                fill="#34A853"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M5.99998 15.375C5.74998 14.75 5.625 14.0833 5.625 13.375C5.625 12.6667 5.74998 12 5.99998 11.375V8.13889H1.83331C1.04165 9.88889 0.625 11.8611 0.625 13.375C0.625 14.8889 1.04165 16.8611 1.83331 18.6111L5.99998 15.375Z"
                fill="#FBBC05"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 5.22222C15.1944 5.22222 17.125 6.05556 18.6111 7.52778L21.3611 4.77778C19.25 2.77778 16.25 1.5 13 1.5C8.11109 1.5 3.88887 4.30556 1.83331 8.38889L5.99998 11.375C6.98609 8.41667 9.74998 6.22222 13 6.22222V5.22222Z"
                fill="#EA4335"
            />
        </g>
        <defs>
            <clipPath id="clip0_331_2879">
                <rect width="26" height="26" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
